import styled from '@emotion/styled';
import { VFC } from 'react';
import Spinner from '../../primitive/Spinner';

type Props = {
  loading?: boolean;
  url: string | undefined;
  className?: string;
};

const PreviewImage: VFC<Props> = ({ loading = false, url, className }) => {
  return <Root className={className}>{loading ? <Spinner /> : <Image url={url} />}</Root>;
};

const Root = styled('div')(`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`);

const Image = styled('div')<{ url: string | undefined }>(
  (props) => `
  height: 100%;
  width: 100%;
  margin: 0px auto;
  background-size: contain;
  background-image: url(${props.url});
  display: block;
  background-repeat: no-repeat;
  background-position: center;
`,
);

export default PreviewImage;
